import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { AI_CAPABILITIES } from "../../data/site";

const NEURAL = "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const AISpotlight = () => {
  return (
    <section data-testid="ai-section" className="relative py-24 md:py-32 overflow-hidden bg-navy-deep">
      {/* neural background */}
      <div className="absolute inset-0 z-0">
        <img src={NEURAL} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep via-navy-deep/85 to-navy-deep/60" />
      </div>

      <div className="container-x relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="overline"
            >
              Flagship Capability
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="font-head text-3xl md:text-5xl font-semibold text-white mt-4 leading-tight"
            >
              AI that creates <span className="text-gradient-orange">measurable value</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="mt-5 text-lg text-slate-300 leading-relaxed max-w-xl"
            >
              From custom AI agents to generative AI integration and intelligent automation, ATS turns emerging AI into production systems that cut cost and unlock new capability.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
            >
              <Link to="/contact" data-testid="ai-cta" className="btn-primary mt-8">
                Talk AI Strategy <ArrowUpRight size={18} />
              </Link>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {AI_CAPABILITIES.map((a, i) => {
              const Icon = a.icon;
              return (
                <motion.div
                  key={a.title}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  whileHover={{ y: -5 }}
                  className="glass rounded-2xl p-6 hover:border-brand-orange/40 transition-colors duration-300"
                >
                  <div className="w-12 h-12 rounded-xl bg-brand-orange/15 grid place-items-center mb-4">
                    <Icon size={22} className="text-brand-orange" />
                  </div>
                  <h3 className="font-head font-semibold text-white text-lg">{a.title}</h3>
                  <p className="text-slate-400 text-sm mt-2 leading-relaxed">{a.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISpotlight;
